export function poundMinus(val, plus = false, decimals = 2, comma = false) {
	var absVal = Math.abs(val).toFixed(decimals); //string
	if (comma) absVal = Number(absVal).toLocaleString(); //should add commas
	return val < 0 ? '-£' + absVal : plus ? '+£' + absVal : '£' + absVal;
}

export function truncateOnWord(str, limit = 30) {
	var trimmable = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';
	var reg = new RegExp('(?=[' + trimmable + '])');
	var words = str.split(reg);
	var count = 0;
	var out = words
		.filter(function(word) {
			count += word.length;
			return count <= limit;
		})
		.join('');
	return out == str ? out : out + '...';
}

export default {
	client_id: 'gUoW6HEvh0GIgAYHWBYlQS6BrGwd9q5pkulqc0Wt',
	client_secret: '0CchcbY9MWuDPBeghLtrbyRv3cWfdSJdvVuH6tQT',
	COLOR: {
		ORANGE: '#C50',
		DARKBLUE: '#0F3274',
		LIGHTBLUE: '#6EA8DA',
		DARKGRAY: '#999'
	}
};
